import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import {
  DocumentTemplatesIcon,
  KpiDefinitionIcon,
  KpiComparisonIcon,
} from "@icarius-icons/index";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("pollSettings"),
      icon: <DocumentTemplatesIcon />,
      path: paths.pollSettings,
    },
    {
      name: getLocalizedString("pollReview"),
      icon: <KpiDefinitionIcon />,
      path: paths.pollReview,
    },
    {
      name: getLocalizedString("pollComparison"),
      icon: <KpiComparisonIcon />,
      path: paths.pollComparison,
    },
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("pollSliderTitle")}
      data={data}
    />
  );
}

export default Index;
